// All editable website content lives here (services, packages, FAQs, etc.).

export const IMG = {
  heroResort:
    "https://images.pexels.com/photos/3011575/pexels-photo-3011575.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  founder:
    "https://images.unsplash.com/photo-1676989880361-091e12efc056?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  lobby:
    "https://images.unsplash.com/photo-1637730827702-de34e9ae4ede?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  room:
    "https://images.unsplash.com/photo-1711059985570-4c32ed12a12c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  villaPool:
    "https://images.unsplash.com/photo-1596178067639-5c6e68aea6dc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  apartment:
    "https://images.unsplash.com/photo-1560185007-5f0bb1866cab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  reception:
    "https://images.unsplash.com/photo-1759038085950-1234ca8f5fed?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  marketing:
    "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  ornateRoom:
    "https://images.pexels.com/photos/34496715/pexels-photo-34496715.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  villa:
    "https://images.unsplash.com/photo-1613977257365-aaae5a9817ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  guesthouse:
    "https://images.unsplash.com/photo-1582610116397-edb318620f90?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const serviceOverview = [
  { icon: "CalendarCheck", title: "Booking Platform Setup", desc: "Get your property listed and running on the platforms guests use to book." },
  { icon: "ListChecks", title: "Listing Optimization", desc: "Complete, accurate and guest-focused listings that build trust and interest." },
  { icon: "Megaphone", title: "Property Marketing", desc: "Digital marketing that puts your property in front of the right travellers." },
  { icon: "MapPin", title: "Google Business Profile", desc: "Improve visibility on Google Search and Maps with a well-structured profile." },
  { icon: "Star", title: "Online Reputation", desc: "Monitor reviews, respond professionally and strengthen your reputation." },
  { icon: "Compass", title: "Hospitality Consulting", desc: "Practical guidance built around your property, guests and goals." },
];

export const whyUs = [
  { icon: "Building2", title: "Hospitality Expertise", desc: "Solutions designed specifically for hotels, guest houses, resorts and property owners." },
  { icon: "LayoutGrid", title: "Multi-Platform Support", desc: "Build and optimize your presence across major travel and booking platforms." },
  { icon: "Sparkles", title: "Professional Presentation", desc: "Make your property look complete, professional and trustworthy online." },
  { icon: "TrendingUp", title: "Booking Growth", desc: "Improve visibility and create more opportunities for potential guests to book." },
  { icon: "Handshake", title: "Transparent Approach", desc: "Clear services, clear communication and customized solutions." },
  { icon: "LifeBuoy", title: "Long-Term Support", desc: "We can continue supporting your property after setup based on your selected package." },
];

export const platforms = [
  { name: "Booking.com", desc: "Establish and optimize your property's presence on one of the world's largest booking platforms." },
  { name: "Airbnb", desc: "Create guest-focused listings with strong descriptions, amenities and pricing presentation." },
  { name: "Agoda", desc: "Expand your reach to travellers searching across the Agoda network." },
  { name: "Expedia", desc: "Reach more potential guests through the Expedia travel ecosystem." },
  { name: "Google Business Profile", desc: "Improve visibility on Google Search and Google Maps." },
  { name: "Tripadvisor", desc: "Strengthen your property's visibility and reputation on Tripadvisor." },
];

export const process = [
  { step: "01", title: "Property Evaluation", desc: "We understand your property, current online presence, challenges and goals." },
  { step: "02", title: "Strategy Development", desc: "We recommend platforms and services based on your property and target guests." },
  { step: "03", title: "Online Setup", desc: "We help establish or improve your presence on relevant platforms." },
  { step: "04", title: "Listing Optimization", desc: "We improve property information, room details, photos, amenities and descriptions." },
  { step: "05", title: "Marketing & Launch", desc: "We help your property reach more potential guests through digital channels." },
  { step: "06", title: "Ongoing Growth Support", desc: "We continue supporting your property based on your selected service package." },
];

export const detailedServices = [
  { icon: "CalendarCheck", title: "Booking.com Setup & Optimization", desc: "Professional setup and optimization of your property's presence on Booking.com, including property information, room details, amenities, policies, photos and listing presentation." },
  { icon: "Home", title: "Airbnb Setup & Optimization", desc: "Create or improve your Airbnb presence with professional property information, descriptions, amenities, pricing presentation and guest-focused content." },
  { icon: "Globe2", title: "Agoda & Expedia Setup", desc: "Expand your property's online reach by establishing and improving your presence on additional travel platforms." },
  { icon: "MapPin", title: "Google Business Profile", desc: "Improve your property's visibility on Google Search and Google Maps with a properly structured and optimized business profile." },
  { icon: "Star", title: "Tripadvisor Presence", desc: "Strengthen your property's online visibility and reputation on Tripadvisor." },
  { icon: "ListChecks", title: "Listing Optimization", desc: "Property descriptions, room descriptions, amenities, policies, photos, location information, guest-focused content and property highlights.", bullets: ["Property descriptions", "Room descriptions", "Amenities & policies", "Photos & location", "Guest-focused content", "Property highlights"] },
  { icon: "Megaphone", title: "Digital Marketing", desc: "Grow your property's digital presence and visibility across the right channels.", bullets: ["Social media strategy", "Content planning", "Promotional campaigns", "Online visibility", "Digital presence"] },
  { icon: "MessageSquare", title: "Online Reputation Management", desc: "Build a trustworthy reputation through consistent, professional review handling.", bullets: ["Review monitoring", "Review response strategy", "Guest feedback", "Reputation improvement"] },
  { icon: "LineChart", title: "Pricing & Revenue Consultation", desc: "Position your property competitively across seasons and market conditions.", bullets: ["Pricing strategy", "Seasonal pricing", "Market positioning", "Occupancy considerations"] },
  { icon: "LifeBuoy", title: "Ongoing Property Support", desc: "Depending on the selected package, HM Services can provide continued support with listings, booking platforms, updates, inquiries and digital growth." },
];

export const packages = [
  {
    name: "Starter",
    tagline: "New or small properties starting their online journey.",
    features: ["Property evaluation", "Google Business Profile guidance", "Basic online presence consultation", "Property information review", "Basic listing strategy", "Consultation"],
    cta: "Request Starter Package",
    recommended: false,
  },
  {
    name: "Basic",
    tagline: "Properties that want to establish themselves on major booking platforms.",
    features: ["Everything in Starter", "Booking.com setup", "Airbnb setup", "Listing optimization", "Property descriptions", "Room and amenity setup", "Basic digital strategy"],
    cta: "Request Basic Package",
    recommended: false,
  },
  {
    name: "Growth",
    tagline: "Properties focused on increasing visibility and booking opportunities.",
    features: ["Everything in Basic", "Agoda setup", "Expedia setup", "Tripadvisor presence", "Advanced listing optimization", "Digital marketing guidance", "Reputation management guidance", "Pricing consultation"],
    cta: "Choose Growth",
    recommended: true,
  },
  {
    name: "Premium",
    tagline: "Properties looking for comprehensive digital hospitality support.",
    features: ["Everything in Growth", "Ongoing listing support", "Booking platform support", "Digital marketing support", "Reputation management", "Pricing/revenue consultation", "Performance review", "Customized growth strategy", "Priority support"],
    cta: "Request Premium",
    recommended: false,
  },
];

export const showcase = [
  {
    name: "Go Guest House Lahore",
    slug: "go-guest-house-lahore",
    city: "Lahore, Pakistan",
    type: "Guest House",
    services: "Hospitality Management • Online Presence • Booking Support",
    desc: "A Lahore-based guest house where we applied our hospitality management experience to improve property presentation, guest service, and online booking operations.",
    image: "/portfolio/go-guest-house-lahore/cover.jpg",
  },
  {
    name: "Second Home Family Hotel",
    slug: "second-home-family-hotel",
    city: "Lahore, Pakistan",
    type: "Family Hotel",
    services: "Hospitality Management • Online Presence • Property Support",
    desc: "A family hotel supported through HM Services with a focus on professional property presentation, guest service, and a stronger online presence.",
    image: "/portfolio/second-home-family-hotel/cover.jpg",
  },
  {
    name: "Waves Guest House Clifton",
    slug: "waves-guest-house-clifton-khi",
    city: "Karachi, Pakistan",
    type: "Guest House",
    services: "Hospitality Management • Online Presence • Booking Support",
    desc: "A Karachi-based guest house supported through HM Services with a focus on professional property presentation, guest service, and online booking operations.",
    image: "/portfolio/waves-guest-house-clifton-khi/cover.jpg",
  },
];

export const faqs = [
  { q: "What does HM Services do?", a: "HM Services helps hotels, guest houses, resorts, villas and other hospitality properties improve their online presence, booking platform listings, digital visibility and overall hospitality business strategy." },
  { q: "Which booking platforms do you work with?", a: "We help properties establish and optimize their presence across platforms such as Booking.com, Airbnb, Agoda, Expedia, Google Business Profile and Tripadvisor." },
  { q: "Do you only work with hotels?", a: "No. We also work with guest houses, resorts, villas, serviced apartments, holiday homes and other hospitality properties." },
  { q: "How much do your services cost?", a: "Pricing depends on the property, number of rooms, platforms and services required. We offer customized packages based on your needs." },
  { q: "Can you manage multiple properties?", a: "Yes. HM Services can work with property owners and managers who operate multiple units or properties. The service structure can be customized according to the portfolio." },
  { q: "Do you guarantee bookings?", a: "We do not guarantee a specific number of bookings. Our focus is on improving your property's online presence, listing quality, visibility and booking opportunities." },
  { q: "How do I get started?", a: "Submit the Free Property Assessment form and tell us about your property. HM Services can then recommend the most suitable services." },
];

export const propertyTypes = ["Hotel", "Guest House", "Resort", "Villa", "Serviced Apartment", "Apartment", "Holiday Home", "Other"];
export const platformOptions = ["Booking.com", "Airbnb", "Agoda", "Expedia", "Google", "Tripadvisor", "None", "Other"];
export const serviceOptions = ["Booking Platform Setup", "Listing Optimization", "Property Marketing", "Google Business Profile", "Reputation Management", "Pricing Consultation", "Ongoing Support"];
export const cities = ["Karachi", "Lahore", "Islamabad", "Rawalpindi", "Multan", "Faisalabad", "Murree", "Nathia Gali", "Hunza", "Skardu", "Swat"];

export const securityPoints = [
  { icon: "Lock", title: "Confidential Handling", desc: "Your business information is handled discreetly and only used for agreed purposes." },
  { icon: "UserCheck", title: "Limited Access", desc: "Sensitive details are shared only with those directly involved in your project." },
  { icon: "MessageSquare", title: "Professional Communication", desc: "Clear, respectful communication throughout our working relationship." },
  { icon: "ShieldCheck", title: "Secure Account Practices", desc: "We follow sensible practices when working with your platform accounts." },
  { icon: "FileCheck", title: "Transparent Processes", desc: "You always know what we are doing and why." },
];
